const CacheNames = {
    UserAccessList: 'USER_ACCESS_LIST',
    InsuranceExpertFieldsCurrentUser: 'INSURANCE_EXPERT_FIELDS_CURRENT_USER',
    UserProfile: 'USER_PROFILE',
    ConfigsByAppKey: 'CONFIGS_BY_APP_KEY',
    VehicleVisitingPoints: 'VEHICLE_VISITING_POINTS',
    VehicleOptions: 'VEHICLE_OPTIONS',
    AutoParts: 'AUTO_PARTS',
    VehicleAccessories: 'VEHICLE_ACCESSORIES',
    VehicleTypes: 'VEHICLE_TYPES',
    VehicleUsages: 'VEHICLE_USAGES',
    VehicleBrands: 'VEHICLE_BRANDS',
    VehicleTips: 'VEHICLE_TIPS',
    VehicleColors: 'VEHICLE_COLORS',
    States: 'STATES',
    Cities: 'CITIES',
    CargoRoom :"CARGO_ROOM",
    FreeZone :"FREE_ZONE",
    Country : "COUNTRY"
}
export default CacheNames